import {Injector, NgModule} from '@angular/core';
import {createCustomElement} from '@angular/elements';
import {BrowserModule} from '@angular/platform-browser';

import { DiscountComponent } from './discount.component';

import { SeFeAlertModule } from 'se-fe-alert';

@NgModule({
  declarations: [ DiscountComponent ],
  imports: [
    BrowserModule,
    SeFeAlertModule,
  ],
})
export class DiscountModule {
  constructor(private injector: Injector) {}

  public ngDoBootstrap() {
    const el = createCustomElement(DiscountComponent, {injector: this.injector});
    if (!customElements.get('discount-element')) { customElements.define('discount-element', el); }
  }
}
